import DOMPurify from "dompurify";
let downloadIframe: HTMLIFrameElement | null = null;

export function buildDownloadUrl(apiBaseUrl: string, endpoint: string, token: string, params?: Record<string, any>): string {
  const cleanEndpointURL = DOMPurify.sanitize(apiBaseUrl + endpoint);
  const url = new URL(cleanEndpointURL);
  url.searchParams.append("key", token);

  if (params) {
    for (const [k, v] of Object.entries(params)) {
      url.searchParams.append(DOMPurify.sanitize(k), DOMPurify.sanitize(String(v)));
    }
  }

  return url.toString();
}

export function safeDownload(url: string): void {
  if (!downloadIframe) {
    downloadIframe = document.createElement("iframe");
    downloadIframe.style.display = "none";
    downloadIframe.setAttribute("sandbox", "allow-downloads allow-same-origin");
    document.body.appendChild(downloadIframe);

    downloadIframe.onload = () => {
      try {
        const doc = downloadIframe!.contentDocument;
        const text = doc?.body?.innerText;

        if (text) {
          downloadIframe?.remove();
          downloadIframe = null;
        }
      } catch (error) {
        console.error("Download iframe error:", error);
      }
    };
  }

  downloadIframe.src = url;
}
